import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TooltipPosition } from '@angular/material/tooltip';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState, InputObservable } from '@y42/angular/util';
import { ErrorHandlerService } from '@y42/error-handling';
import { Observable, switchMap } from 'rxjs';
import { AbstractFeatureUIModel } from '../../../models';
import { AssetSidebarTabType } from '../asset-sidebar-tab.model';
import { AssetSidebarService } from '../asset-sidebar.service';

@UntilDestroy()
@Component({
  selector: 'y42-share-asset-button',
  templateUrl: './share-asset-button.component.html',
  styleUrls: ['./share-asset-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShareAssetButtonComponent {
  constructor(
    private readonly assetSidebarService: AssetSidebarService,
    private readonly errorHandlerService: ErrorHandlerService,
  ) {}

  @Input()
  @InputObservable()
  path?: AbstractFeatureUIModel['$path'];
  path$!: Observable<AbstractFeatureUIModel['$path'] | undefined>;
  @Input()
  tooltipPosition: TooltipPosition = 'right';

  public readonly state = connectState(this, {
    isActive: this.path$.pipe(switchMap(($path) => this.assetSidebarService.selectIsActive($path))),
  });

  openInAssetSidebar(evt: MouseEvent) {
    if (!this.path) {
      this.errorHandlerService.handleError(`[OpenInAssetSidebarButton]: missing path`);
      return;
    }

    evt.stopPropagation();

    if (this.state.isActive) {
      this.assetSidebarService.close();
    } else {
      this.assetSidebarService.setActiveTab(AssetSidebarTabType.ACL, this.path);
    }
    return false;
  }
}
